import { render, staticRenderFns } from "./1090135.vue?vue&type=template&id=745827b5&"
import script from "./1090135.vue?vue&type=script&lang=js&"
export * from "./1090135.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports